'use strict';

const s = require('bootstrap-select');
const { default: i18n } = require('i18next');
const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const Radio = require('backbone.radio');
const template = require('../../templates/languages.hbs');
const Language = require('../../Language');

const navChannel = Radio.channel('controller');

const getModel = () => {
  const model = new (Backbone.Model.extend({}))();
  const items = Language.LANGUAGES.map(
    lang => ({
      id:       lang,
      name:     i18n.t(`common:lang-${lang}`),
      selected: (Language.currentLanguage.name === lang
         && Language.currentLanguage.source !== Language.LANGUAGE_SOURCE.BROWSER),
    })
  );
  if (Language.BROWSER_LANGUAGE) {
    items.unshift({
      id:       'browser',
      name:     i18n.t('common:lang-browser'),
      selected: (Language.currentLanguage.name === Language.BROWSER_LANGUAGE
         && Language.currentLanguage.source === Language.LANGUAGE_SOURCE.BROWSER),
    });
  }
  model.set({
    languages: items,
  });

  return model;
};

const LanguagesView = Marionette.ItemView.extend({
  template,
  ui: { languages: '#languages' },

  initialize: function fInitialize({ parent }) {
    this.model = getModel();

    if (parent.onChangeLanguage && typeof parent.onChangeLanguage === 'function') {
      this.onLanguageChanged = parent.onChangeLanguage.bind(parent);
    } else {
      this.onLanguageChanged = parent.render.bind(parent);
    }
  },

  events: {
    'change @ui.languages': 'onClick',
  },

  onClick: function fClick(ev) {
    ev.stopImmediatePropagation();
    ev.preventDefault();

    let lang = ev.target.value;
    let source = Language.LANGUAGE_SOURCE.USER;

    if (lang === 'browser') {
      lang = Language.BROWSER_LANGUAGE;
      source = Language.LANGUAGE_SOURCE.BROWSER;
    }

    Language.setPreferred(lang, source)
      .then(() => {
        this.onLanguageChanged();
      });

    navChannel.trigger('LANGUAGE_CHANGE');

    return false;
  },

  onLanguageChanged: () => {},
});

const showLanguagesView = function fShow({ parent }) {
  if (!Language.enabled) {
    return null;
  }

  if (!parent) throw new Error('parent view not specified');
  if (!parent.ui || !parent.ui.language) throw new Error('parent.ui.language view not specified');

  const languagesView = new LanguagesView({
    el: parent.ui.language,
    parent,
  });
  languagesView.render();
  setTimeout(() => {$('#languages').selectpicker({})}, 10) ;
  return languagesView;
};

module.exports = showLanguagesView;
